export default __webpack_public_path__ + "assets/number.3e92cd92.svg";